import { IApiQueryData, ISearchPageActionState } from '../interfaces';
import { FILTER_ITEM_SELECT_DEBOUNCE_TIME_MS, PARAM_PAGE, PARAM_SEARCH } from '../constants';
import { ISetSearchFieldTextPayload } from '../actions/search';

export const doSetSearchFieldText = (state: ISearchPageActionState, payload: ISetSearchFieldTextPayload): ISearchPageActionState => {
    const newApiQueryParams: IApiQueryData = {
        ...state.apiQueryData,
        [PARAM_SEARCH]: payload.newSearchTerm,
        [PARAM_PAGE]: '1',
    };

    return {
        ...state,
        apiQueryData: newApiQueryParams,
        updatePageDebounceTime: FILTER_ITEM_SELECT_DEBOUNCE_TIME_MS,
    };
};

export const doResetSearchFieldText = (state: ISearchPageActionState): ISearchPageActionState => {
    const newApiQueryParams: IApiQueryData = {
        ...state.apiQueryData,
        [PARAM_SEARCH]: '',
    };

    return {
        ...state,
        apiQueryData: newApiQueryParams,
    };
}
